import React from 'react';
import './sidebar-links.style.scss';

function SidebarLinks() {
    return (
        <div className='sidebar-links'>
            <ul>
                <li>Legal</li>
                <li>Privacy Center</li>
                <li>Privacy Policy</li>
                <li>Cookies</li>
                <li>About Ads</li>
                <li>Accessibility</li>
            </ul>
            <li>Cookies</li>
        </div>
    )
}

export default SidebarLinks;
